import React from 'react';

// Literal class strings: Tailwind only ships what it can read.
const COLS = {
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4'
};

/**
 * A group of cards that is a sideways strip on a phone (snap scroll, a peek
 * of the next card — the standard for card rows) and a grid from `md` up.
 * `phone="grid2"` makes the phone a two-column grid instead (New places).
 *
 * Children are the cards; each gets the slot wrapper here, so a card
 * component doesn't need to know which layout it's in.
 */
export const STRIP_SLOT = 'flex-shrink-0 w-[80vw] max-w-72 snap-start md:w-auto md:max-w-none';

export default function CardGroup({ cols = 3, phone = 'strip', className = '', children }) {
  const grid = COLS[cols] || COLS[3];
  if (phone === 'grid2') {
    return (
      <div className={`grid grid-cols-2 gap-3 ${grid} md:gap-5 ${className}`}>
        {children}
      </div>
    );
  }
  return (
    <div className={`flex gap-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory -mx-4 px-4 pt-1 pb-3 md:mx-0 md:px-0 md:pb-0 md:grid ${grid} md:gap-5 md:overflow-visible ${className}`}>
      {children}
    </div>
  );
}
